/**
 * Em'z Blendz Soap on a Rope add-on
 *
 * Pairs with snippets/rope-addon.liquid, which renders a checkbox in the
 * buy box of products tagged "rope-eligible". When the box is checked,
 * this script intercepts the add to cart submit and adds two lines: the
 * soap exactly as the theme would have added it, then the rope variant at
 * the same quantity with a "Rope for" line item property for fulfillment.
 * The cart drawer is notified once, after both adds settle, so it opens
 * showing both lines.
 *
 * The submit listener runs on document in the capture phase, which fires
 * before theme.AjaxProduct's form level listener. When the checkbox is
 * unchecked or hidden the listener does nothing and the stock theme flow
 * runs untouched. A failed rope add never blocks the soap: the soap stays
 * in the cart and a small note appears in the block.
 *
 * Everything is delegated at the document level so blocks injected later
 * (quick view modals) work without re-initialization. Both the theme's
 * variant code and emz-variant-handler.js dispatch "variant:change" on
 * document, so one listener covers every selection path, including the
 * sticky bar's variant drawer.
 */
(function () {
  'use strict';

  if (window.emzRopeAddonLoaded) return;
  window.emzRopeAddonLoaded = true;

  var loading = false;

  function cartAddUrl() {
    if (window.theme && theme.routes && theme.routes.cartAdd) {
      return theme.routes.cartAdd;
    }
    return '/cart/add.js';
  }

  function isSmallTitle(title) {
    return typeof title === 'string' && title.toLowerCase().indexOf('small') !== -1;
  }

  function setBlockState(block, small) {
    var option = block.querySelector('[data-rope-option]');
    var note = block.querySelector('[data-rope-note]');
    var checkbox = block.querySelector('[data-rope-checkbox]');

    if (small && checkbox) {
      checkbox.checked = false;
    }
    if (option) option.hidden = small;
    if (note) note.hidden = !small;
    block.dataset.state = small ? 'small' : 'large';
  }

  document.addEventListener('variant:change', function (evt) {
    var variant = evt.detail && evt.detail.variant;
    if (!variant || !variant.id) return;

    var variantId = String(variant.id);
    document.querySelectorAll('[data-rope-addon]').forEach(function (block) {
      var ids = (block.dataset.variantIds || '').split(',');
      if (ids.indexOf(variantId) === -1) return;
      setBlockState(block, isSmallTitle(variant.title));
    });
  });

  // The subscription widget dispatches this on every purchase option
  // change, with an empty id when One-Time is selected. The label shows
  // the rope's price under the chosen plan (plan prices carry the
  // subscription discount).
  document.addEventListener('sealsubs:change_selected_selling_plan_id', function (evt) {
    var planId = evt.detail && evt.detail.selling_plan_id ? String(evt.detail.selling_plan_id) : '';

    document.querySelectorAll('[data-rope-addon]').forEach(function (block) {
      var priceEl = block.querySelector('[data-rope-price]');
      if (!priceEl) return;

      var planPrices = {};
      try {
        planPrices = JSON.parse(block.dataset.planPrices || '{}');
      } catch (err) {
        console.warn('[EMZ Rope] Could not parse plan prices', err);
      }
      priceEl.textContent = planPrices[planId] || block.dataset.basePrice;
    });
  });

  // The sticky bar form has no form id match, so it falls back to product
  // id, which its hidden variant input carries and keeps in sync with the
  // main form.
  function findBlockForForm(form, productId) {
    var blocks = document.querySelectorAll('[data-rope-addon]');
    var byProduct = null;

    for (var i = 0; i < blocks.length; i++) {
      if (form.id && blocks[i].dataset.formId === form.id) return blocks[i];
      if (productId && !byProduct && blocks[i].dataset.productId === productId) {
        byProduct = blocks[i];
      }
    }
    return byProduct;
  }

  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!(form instanceof HTMLFormElement)) return;

    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;

    var block = findBlockForForm(form, idInput.getAttribute('data-product-id'));
    if (!block || block.dataset.state !== 'large') return;

    var checkbox = block.querySelector('[data-rope-checkbox]');
    if (!checkbox || !checkbox.checked) return;

    evt.preventDefault();
    evt.stopImmediatePropagation();

    if (loading) return;
    addSoapThenRope(form, block);
  }, true);

  function addSoapThenRope(form, block) {
    loading = true;

    var submitBtn = form.querySelector('[data-add-to-cart]') || form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.classList.add('btn--loading');

    var errorEl = block.querySelector('[data-rope-error]');
    if (errorEl) errorEl.hidden = true;

    var soapData = new FormData(form);
    var quantity = parseInt(soapData.get('quantity'), 10);
    if (isNaN(quantity) || quantity < 1) quantity = 1;

    var sellingPlan = (soapData.get('selling_plan') || '').toString().trim();

    fetch(cartAddUrl(), {
      method: 'POST',
      body: soapData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) { return response.json(); })
      .then(function (soap) {
        if (soap.status) {
          showFormError(form, soap);
          return null;
        }
        return addRope(block, quantity, sellingPlan).then(function (ropeAdded) {
          if (!ropeAdded && errorEl) errorEl.hidden = false;
          var ropeMessage = !ropeAdded && errorEl ? errorEl.textContent.trim() : '';
          announceSuccess(form, soap, submitBtn, ropeMessage);
        });
      }, function (err) {
        // A lost soap response may still mean it was added. Never retry it here.
        loading = false;
        if (submitBtn) submitBtn.classList.remove('btn--loading');
        console.warn('[EMZ Rope] Soap addition could not be confirmed', err);
        showFormError(form, {
          description: theme.strings.cartAddUnconfirmed,
          checkCart: true
        });
      })
      .catch(function (err) {
        console.warn('[EMZ Rope] Add to cart request failed', err);
      })
      .then(function () {
        loading = false;
        if (submitBtn) submitBtn.classList.remove('btn--loading');
      });
  }

  // Keep the chosen selling plan. Never replay a rope mutation automatically:
  // a lost response or even a stock-limit error may follow a partial addition.
  function addRope(block, quantity, sellingPlan) {
    var properties = {};
    properties['Rope for'] = block.dataset.productTitle;

    var payload = {
      id: parseInt(block.dataset.ropeVariantId, 10),
      quantity: quantity,
      properties: properties
    };
    if (sellingPlan) payload.selling_plan = sellingPlan;

    return postRope(payload);
  }

  function postRope(payload) {
    return fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json().then(function (rope) {
          return !!(response.ok && rope && typeof rope === 'object' && !Array.isArray(rope) &&
            !rope.status && !rope.errors && String(rope.id) === String(payload.id));
        });
      })
      .catch(function () { return false; });
  }

  // Mirrors theme.AjaxProduct's success path so the cart drawer and any
  // other ajaxProduct:added listeners behave exactly as on a stock add.
  function announceSuccess(form, soap, submitBtn, ropeMessage) {
    var errors = form.querySelector('.errors');
    if (errors) errors.remove();

    var pageCart = window.theme && theme.settings && theme.settings.cartType === 'page';
    var onCartPage = document.body.classList.contains('template-cart');
    var usableDrawer = !pageCart && !onCartPage && theme.cartDrawer &&
      theme.cartDrawer.form && theme.cartDrawer.form.isConnected;
    if (pageCart && !ropeMessage) {
      window.location = theme.routes.cartPage;
      return;
    }

    form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: {
        product: soap,
        addToCartBtn: submitBtn,
        ropeUnconfirmedMessage: ropeMessage || '',
        ropeLocalRecovery: !!ropeMessage && !usableDrawer
      },
      bubbles: true
    }));

    if (ropeMessage && !usableDrawer) {
      // Keep uncertainty visible until the shopper chooses the ordinary cart link.
      showFormError(form, { description: ropeMessage, checkCart: true });
      return;
    }

    if (onCartPage) {
      window.scrollTo(0, 0);
      location.reload();
    }
  }

  // Mirrors theme.AjaxProduct's error path.
  function showFormError(form, error) {
    if (!error.description) {
      console.warn(error);
      return;
    }

    var errors = form.querySelector('.errors');
    if (errors) errors.remove();

    var errorDiv = document.createElement('div');
    errorDiv.classList.add('errors', 'text-center');

    if (typeof error.description === 'object') {
      errorDiv.textContent = error.message;
    } else {
      errorDiv.textContent = error.description;
    }

    if (error.checkCart) {
      errorDiv.setAttribute('role', 'alert');
      var cartLink = document.createElement('a');
      cartLink.href = theme.routes.cartPage;
      cartLink.textContent = theme.strings.cartCheckBeforeRetry;
      cartLink.style.textDecoration = 'underline';
      cartLink.style.setProperty('color', 'inherit', 'important');
      cartLink.style.setProperty('outline-color', 'currentColor', 'important');
      errorDiv.append(document.createTextNode(' '), cartLink);
    }

    form.append(errorDiv);

    form.dispatchEvent(new CustomEvent('ajaxProduct:error', {
      detail: {
        errorMessage: error.description
      },
      bubbles: true
    }));
  }
})();
